import './header-footer.scss';

export const Footer = () => {
    return (
        <footer className='footer'>
            <p className='footer-inner'>
                Copyright <span>&copy;</span> 2022 Pohorila Vladylena. All rights reserved.
            </p>
        </footer>
    )
}